import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { integrationsService } from '../services/integrations';

const key = ['integrations'] as const;

export function useIntegrations() {
  return useQuery({ queryKey: key, queryFn: () => integrationsService.list() });
}

export function useSetIntegration() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ kind, value }: { kind: string; value: string }) =>
      integrationsService.setValue(kind, value),
    onSuccess: () => qc.invalidateQueries({ queryKey: key }),
  });
}

export function useRemoveIntegration() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (kind: string) => integrationsService.remove(kind),
    onSuccess: () => qc.invalidateQueries({ queryKey: key }),
  });
}
